<template>
  <a-card type="inner" size="small">
    <a-skeleton :loading="loading" active>
      <a-table :columns="columns" :dataSource="items.data" rowKey="id"
               :pagination="{ pageSize: pageSize, current: items.current_page, total: items.total, showSizeChanger: true }"
               @change="tableChanged">

        <div slot="sponsor" slot-scope="record">
          <a-button size="small" type="link" icon="tags"/>
          {{ record.sponsor.sponsor_name }}
        </div>

        <div slot="billerName" slot-scope="record">
          <h4>{{ record.biller_disbursement_account.biller.contact_name }}</h4>
        </div>

        <div slot="productGroupName" slot-scope="record">
          <h4>{{ record.biller_disbursement_account.product_group.name }}</h4>
        </div>

        <div slot="sponsorAccount" slot-scope="record">
          <h4>{{ record.sponsor_account }}</h4>
        </div>

        <h4 slot="sponsorFee" slot-scope="record">
          <currency :amount="record.sponsor_fee" />
        </h4>

        <p slot="updatedAt" slot-scope="updated_at" class="text-sm">
          <a-tooltip :title="moment(updated_at).format('YYYY-MM-DD HH:mm:ss')">
            {{ moment(updated_at).fromNow() }}
          </a-tooltip>
        </p>

        <div slot="action" slot-scope="record">
          <a-tooltip title="Edit Sponsor Config">
            <a-button size="small" type="primary" icon="edit" :href="routeUri('hyperion.finances.sponsor-config.edit', { sponsor_config: record.id })"/>
          </a-tooltip>
        </div>
      </a-table>
    </a-skeleton>
  </a-card>
</template>

<script>
import {sponsorConfig as columns} from "../../../../tables"

export default {
  data() {
    return {
      columns,
      form: this.$form.createForm(this),
      loading: false,
      expand: false,
      items: {},
      filters: {
        q: null,
        page: 1,
        per_page: 10,
        sponsors: []
      }
    }
  },
  created() {
    this.items = this.getDefaultPagination()
    this.filters = _.merge(this.filters, this.$hyperion.request)
    this.getItems()
  },
  computed: {
    pageSize() {
      return parseInt(this.items.per_page)
    }
  },
  methods: {
    tableChanged(pagination) {
      this.filters.page = pagination.current
      this.filters.per_page = pagination.pageSize
      this.pushState(this.filters)
      this.getItems()
    },
    handleSubmit(e) {
      e.preventDefault()
      this.pushState(this.filters)
      this.getItems()
    },
    handleAutocomplete(v, iteratee) {
      if (v.length === 0) {
        this.filters[iteratee] = []
      } else {
        this.filters[iteratee] = _.map(v, (o) => o.id)
      }
    },
    handleReset(e) {
      e.preventDefault()
      this.filters = {
        q: null,
        page: 1,
        groups: []
      }
    },
    getItems() {
      this.loading = true
      this.$http.get(this.routeUri('hyperion.finances.sponsor-config'), {
        params: this.filters
      })
        .then((response) => this.items = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    }
  }
}
</script>
